export default {
  methods: {
    viewSuccess(title = 'Operación exitosa', message = 'Los datos se han guardado correctamente') {
      const h = this.$createElement;

      let titleElement = h('strong', null, title);
      let messageElement = h('span', null, message);

      this.$bvToast.toast([messageElement], {
        title: [titleElement],
        solid: true,
        variant: 'success'
      });
    },
    viewErrors(title = 'No hemos podido procesar su solicitud', errors = []) {
      const h = this.$createElement;
      let titleElement = h('strong', title);
      let messageElement = h('span', this.createMessageError(errors));

      this.$bvToast.toast([messageElement], {
        title: [titleElement],
        solid: true,
        variant: 'danger'
      });
    },
    createMessageError(errors) {
      const h = this.$createElement;

      return errors.map(error => h('div', error));
    }
  }
}